import React, { useEffect, useState } from 'react';
import api, { unwrap } from '../utils/api';
import Icon from '../components/Icon';

export default function FieldLayoutPresets() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  async function load() {
    setLoading(true);
    try {
      const r = await api.get('/miscellaneous/fieldLayoutPresets');
      setItems(unwrap(r) || []);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => { load(); }, []);

  async function rename(item) {
    const next = window.prompt('Rename preset:', item.name);
    if (!next || next.trim() === item.name) return;
    await api.post('/miscellaneous/fieldLayoutPresets/update', { _id: item._id, name: next.trim() });
    load();
  }

  async function editDescription(item) {
    const next = window.prompt('Description:', item.description || '');
    if (next === null) return;
    await api.post('/miscellaneous/fieldLayoutPresets/update', { _id: item._id, description: next });
    load();
  }

  async function remove(item) {
    if (!window.confirm(`Delete preset "${item.name}"? This cannot be undone.`)) return;
    await api.post('/miscellaneous/fieldLayoutPresets/delete', { _id: item._id });
    load();
  }

  return (
    <>
      <h1>Field Layout Presets</h1>
      <p style={{ color: '#666', marginTop: -4 }}>
        Reusable sets of text-field layouts. Create a preset by laying out fields on any template, then clicking "Save as preset" in the field editor. When you upload a new template, the preset appears in the "Load layout preset" dropdown.
      </p>

      <div className="card">
        {loading ? (
          <p style={{ color: '#888' }}>Loading…</p>
        ) : items.length === 0 ? (
          <p style={{ color: '#888' }}>
            No presets yet. Open a product's field editor, lay out your text boxes, then click <strong><Icon name="save" /> Save as preset</strong>.
          </p>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th style={{ width: 100 }}>Fields</th>
                <th style={{ width: 160 }}>Canvas size</th>
                <th style={{ width: 180 }}>Created</th>
                <th style={{ width: 220 }}></th>
              </tr>
            </thead>
            <tbody>
              {items.map(i => (
                <tr key={i._id}>
                  <td><strong>{i.name}</strong></td>
                  <td style={{ color: '#666' }}>{i.description || <em style={{ color: '#bbb' }}>— none —</em>}</td>
                  <td>{(i.fields || []).length}</td>
                  <td style={{ color: '#666' }}>
                    {i.canvasWidth && i.canvasHeight ? `${i.canvasWidth} × ${i.canvasHeight}` : '—'}
                  </td>
                  <td style={{ color: '#666' }}>
                    {i.createdAt ? new Date(i.createdAt).toLocaleString() : ''}
                  </td>
                  <td>
                    <button className="btn small secondary" onClick={() => rename(i)} style={{ marginRight: 4 }}>Rename</button>
                    <button className="btn small secondary" onClick={() => editDescription(i)} style={{ marginRight: 4 }}>Description</button>
                    <button className="btn small danger" onClick={() => remove(i)}>Del</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}
